<template>
  <div>
    <!--
    <div class="layout">
      <div class="align-between">
        <div class="title-select-wrap">
          <button type="button" class="title" ref="subMenuTitle" @click="eventClickSubMenu($event.target)">대회 안내</button>          
          <div ref="subMenuItem">
            <ul class="subGnb-depth03 title-menu">
              <li>
                <router-link :to="{name: '통계 데이터 활용 대회'}">대회 안내</router-link>
              </li>
              <li>
                <router-link :to="{name: '대회 공지사항'}">대회 공지사항</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    -->
    <div class="layout">
      <div class="img_view">
        <img src="../../assets/img/duc_infomation.png" alt="">
      </div>
      <div class="btn_view">
        <button type="button" @click="openDucRegistpage()" class="btn_reg" title="데이터 활용대회 참가자 등록">데이터 활용대회 참가자 등록</button>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  name: 'DucInfomation',
  mounted() {
    const currentMenu = document.querySelector('.router-link-active').innerText
    document.querySelector('.title-select-wrap > button').textContent = currentMenu
  },
  methods: {
    eventClickSubMenu (target) {
      if (target) {
        const subMenuItemDiv = target.nextElementSibling
        if (subMenuItemDiv && subMenuItemDiv.children) {
          const subMenuItemUl = subMenuItemDiv.querySelector('.subGnb-depth03')
          const obj = subMenuItemUl.children[0]
          if (subMenuItemUl.style.display === 'block') {
            $(subMenuItemDiv.children[0]).stop().slideUp()
          } else {
            $(subMenuItemDiv.children[0]).stop().slideDown()
          }
        }
      }
    },
    openDucRegistpage () {
      const openUrl = 'https://stat.mcst.go.kr/mng/survey/webNew?seq=W_5758'
      window.open(openUrl, '_blank')
    }
  }
}
</script>
<style>
.img_view, .btn_view {
  width: 100%;
  display: flex;
  justify-content: center;
}
.btn_view {
  margin-top: 50px;
}
.btn_reg {
  background-color: #007bce;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 30px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  display: inline-block;
  font-weight: bold;
}

.btn_reg:hover {
  background-color: #005fa3;
}

@media only screen and (max-width: 1024px){
  .img_view img{
        width:100%;
        height:auto;
    }
}
</style>
